import React, { useEffect, useState } from 'react';
import { Box, Container, Grid, Link, Typography } from '@mui/material';

const feedUrl = process.env.REACT_APP_INSITECH_TESTIMONIALS_URL
  || 'https://api.insitechinternational.com/api/v1/testimonials';

export default function CentralTestimonials({ platform }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    const url = new URL(feedUrl);
    url.searchParams.set('platform', platform);
    fetch(url, { signal: controller.signal })
      .then((response) => response.ok ? response.json() : { testimonials: [] })
      .then((body) => setItems(Array.isArray(body.testimonials) ? body.testimonials : []))
      .catch((error) => { if (error.name !== 'AbortError') setItems([]); });
    return () => controller.abort();
  }, [platform]);

  if (!items.length) return null;

  return (
    <Box component="section" aria-labelledby="customer-voices" sx={{ py: { xs: 7, md: 10 }, bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Typography id="customer-voices" variant="h3" fontWeight={800} textAlign="center" sx={{ mb: 5 }}>
          What our learners say
        </Typography>
        <Grid container spacing={3}>
          {items.slice(0, 3).map((item) => (
            <Grid item xs={12} md={4} key={item.id}>
              <Box component="figure" sx={{ m: 0, p: 3, height: '100%', border: 1, borderColor: 'divider', borderRadius: 3 }}>
                <Typography component="blockquote" sx={{ m: 0, lineHeight: 1.8 }}>
                  “{item.short_quote || item.quote}”
                </Typography>
                <Box component="figcaption" sx={{ mt: 3, pt: 2, borderTop: 1, borderColor: 'divider' }}>
                  <Typography fontWeight={700}>{item.person_name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {[item.person_role, item.company].filter(Boolean).join(', ')}
                  </Typography>
                  {item.source_url ? <Link href={item.source_url} target="_blank" rel="noreferrer" variant="caption">View source</Link> : null}
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
